// src/ConsumerApp/api/rfq/rfq.hooks.js
import { useQuery } from '@tanstack/react-query';
import { RfqService } from './rfq.service';

/**
 * Hook to fetch RFQs list for a specific customer
 */
export const useGetRfqsByCustomer = ({ customerId, rfqs = 'all' }) => {
  return useQuery({
    queryKey: ['customerRfqs', customerId, rfqs],
    queryFn: async () => {
      try {
        const response = await RfqService.getRfqsByCustomer({ customerId, rfqs });
        return response?.data || response || [];
      } catch (error) {
        if (error?.status === 404 || error?.message?.includes('No RFQs found')) {
          return [];
        }
        throw error;
      }
    },
    enabled: Boolean(customerId),
    staleTime: 1000 * 60 * 2, // 2 minutes
  });
};

/**
 * Hook to fetch single RFQ detail record by ID
 */
export const useGetRfqById = (rfqId) => {
  return useQuery({
    queryKey: ['rfqDetails', rfqId],
    queryFn: async () => {
      const response = await RfqService.getRfqById(rfqId);
      return response?.data || response || null;
    },
    enabled: Boolean(rfqId),
    staleTime: 1000 * 60 * 2,
  });
};